import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {
  TrendingQueriesQuery,
  TrendingQueriesQueryVariables,
  TrendingQueriesQuery_autocomplete_trending_queries as TrendingQuery
} from '../../generated/types/TrendingQueriesQuery';
import { QuickSearchResults } from './QuickSearchResults';

interface Props {
  mobile?: boolean;
  onEnter(): void;
  onClose(): void;
}

export const TRENDING_QUERIES_QUERY = gql`
  query TrendingQueriesQuery($limit: Int) {
    autocomplete(limit: $limit) {
      trending_queries {
        query
        destination_path
      }
    }
  }
`;

const LIMIT = 5;

export const TrendingQueries: React.FC<Props> = ({ mobile, onEnter, onClose }) => {
  const { data, loading, error } = useQuery<TrendingQueriesQuery, TrendingQueriesQueryVariables>(
    TRENDING_QUERIES_QUERY,
    {
      variables: { limit: LIMIT }
    }
  );

  const results =
    data?.autocomplete?.trending_queries
      ?.filter((query): query is TrendingQuery => query !== null)
      .map(query => ({
        name: query.query || '',
        value: query.query || '',
        href: query.destination_path || ''
      })) || [];

  const resultSets = [
    {
      type: 'trendingQuery',
      title: 'Trending Queries',
      results
    }
  ];

  return (
    <QuickSearchResults
      mobile={mobile}
      query=""
      loading={loading}
      error={error}
      results={results}
      resultSets={resultSets}
      onEnter={onEnter}
      onClose={onClose}
    />
  );
};
